import { Paper, Stack, Typography } from "@mui/material";

export const FormCardLayout = ({ title, children, caption = null }) => {
  return (
    <Stack
      component={Paper}
      flexDirection={{ xs: "column", md: "row" }}
      sx={{ p: "32px 24px", gap: "32px" }}
      borderRadius={0}
    >
      <Stack width="300px" gap="8px">
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        {caption && (
          <Typography variant="subtitle2" color="text.secondary">
            {caption}
          </Typography>
        )}
      </Stack>
      <Stack width="100%">{children}</Stack>
    </Stack>
  );
};
